import React from 'react'
import { Grid } from 'semantic-ui-react'

// @ts-ignore
import LKButton from 'shared/LKButton'
// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'
// @ts-ignore
import { GridContainer } from 'shared/StyledComponents'

import { isRequired } from '../../../helpers'
import translate from '../../translate'

import container from './container'

const AddressInformation = ({
  fields,
  cityList,
  selects,
  copyAddressFromOfficialAddress,
  noVisibilityFilter,
  onTranslateAltRequest,
  onCountryChange,
}) => (
  <GridContainer smallPadding>
    <Grid.Row columns={1}>
      <Grid.Column>
        {(!!fields.Address || !!fields.CityID || !!fields.Address) && (
          <FormLayout
            visible={noVisibilityFilter || !!(fields.Address || fields.CityID)}
            fieldProportions="3:3:6:3"
            label={translate('lbl_legal_address')}
          >
            {!!selects.Country && (
              <FormField
                type="select"
                name="CountryID"
                onChange={(value) => onCountryChange(value, 'CityID')}
                options={selects.Country}
                search
              />
            )}
            {!!fields.CityID && (
              <FormField
                visible={noVisibilityFilter || !!fields.CityID}
                name="CityID"
                options={cityList.CityIDList}
                required={isRequired(fields.CityID)}
                type="select"
                search
              />
            )}
            {!!fields.Address && (
              <FormField
                visible={noVisibilityFilter || !!fields.Address}
                name="Address"
                required={isRequired(fields.Address)}
                type="text"
                autoFocus
                maxLength={fields.Address ? fields.Address.MaxLen : -1}
                onBlur={onTranslateAltRequest('Address_ALT')}
              />
            )}
            {/* {!!fields.Address_ALT && ( */}
            <FormField
              visible={noVisibilityFilter}
              name="Address_ALT"
              placeholder={translate('txt_address_alt')}
              required={isRequired(fields.Address_ALT)}
              type="text"
              maxLength={fields.Address_ALT ? fields.Address_ALT.MaxLen : -1}
            />
            {/* )} */}
            <div />
          </FormLayout>
        )}

        {(!!fields.Address2 || !!fields.City2ID) && (
          <FormLayout
            visible={noVisibilityFilter || !!(fields.Address2 || fields.City2ID)}
            fieldProportions="3:3:6:3:1"
            label={translate('lbl_curr_address')}
          >
            {!!selects.Country && (
              <FormField
                type="select"
                name="Country2ID"
                onChange={(value) => onCountryChange(value, 'City2ID')}
                options={selects.Country}
                search
              />
            )}
            {!!fields.City2ID && (
              <FormField
                visible={noVisibilityFilter || !!fields.City2ID}
                name="City2ID"
                options={cityList.City2IDList}
                required={isRequired(fields.City2ID)}
                type="select"
                search
              />
            )}
            {!!fields.Address2 && (
              <FormField
                visible={noVisibilityFilter || !!fields.Address2}
                name="Address2"
                required={isRequired(fields.Address2)}
                type="text"
                maxLength={fields.Address2 ? fields.Address2.MaxLen : -1}
                onBlur={onTranslateAltRequest('Address2_ALT')}
              />
            )}
            <FormField
              visible={noVisibilityFilter}
              name="Address2_ALT"
              placeholder={translate('txt_address2_alt')}
              required={isRequired(fields.Address2_ALT)}
              type="text"
              maxLength={fields.Address2_ALT ? fields.Address2_ALT.MaxLen : -1}
            />

            {!!(fields.Address && fields.CityID) && (
              <LKButton onClick={copyAddressFromOfficialAddress} alias="down_big" />
            )}
          </FormLayout>
        )}
      </Grid.Column>
    </Grid.Row>
  </GridContainer>
)

export default container(AddressInformation)
